var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex justify-space-between" },
    [
      _vm.icon
        ? _c("display-icon-badge-tooltip", {
            attrs: { icon: _vm.icon, "tooltip-text": _vm.iconTooltip }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex font-weight-bold text-center align-self-center"
        },
        [_vm._v("\n    " + _vm._s(_vm.title) + "\n    "), _vm._t("default")],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "subtitle-2 font-italic text-right" }, [
        _vm._v(
          "\n    " + _vm._s(_vm.date && _vm.date.toLocaleString()) + "\n  "
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }